/*
 * @Author: JamesWong
 * @Description: 小票配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2021-03-18 20:06:15
 */
export default {
  styleDisposition: 'Style Disposition',
  ticketPreview: ' Ticket Preview',
  detail: 'Detail',
  edit: 'Edit',
  save: 'Save',
  cancel: 'Cancel',
  printLabel: 'Print Label',
  reprintLabel: 'Reprint Label(Display only on reprinted receipts)',
  headPhotos: 'Head Photos',
  headPart: 'Head Part',
  ticketInfo: 'Ticket Info',
  ticketNo: 'Ticket No.',
  operateTime: 'Operate Time',
  cashier: 'Cashier',
  assistant: 'Staff',
  assistantCode: 'Staff No.',
  assistantName: 'Staff Name',
  storeNo: 'Store No.',
  storeAddr: 'Store Addr',
  storePhone: 'Store Phone',
  storeMobile: 'Store Mobile',
  VIPNo: 'VIP No.',
  remarks: 'Sales Remark',
  Goods: 'Goods',
  Quty: 'Quty',
  Amt: 'Amt',
  Total: 'Total',
  PriceTotal: 'Price Total',
  Benefit: 'Benefit',
  Change: 'Change',
  ValueBalance: 'Value Balance',
  VIPPrice: 'VIP Price',
  DCT: 'DCT',
  DiscountedPrice: 'Discounted Price',
  TagPrice: 'Tag Price',
  goodsInfo: 'Goods Info',
  promotionInfo: 'Promotion Info',
  allPromotionsTicket: 'All Promotions on this Ticket',
  promotionDesc: 'Promotion Description',
  promotionNotes: 'Promotion Notes',
  paymentMethod: 'Payment Method',
  defaultPayment: 'Default style: due+all applied payment methods',
  tailPhotos: 'Tail Photos',
  salesExplanation: 'Sales Explanation',
  tailpart: 'Tail part',
  quantitySet: 'Quantity Set',
  salesCreateReciept: 'Sales Create Reciept',
  createDeposit: 'Create Deposit',
  numberChannelVersion: 'Number of Printing Channel Version',
  complete: 'Complete',
  numberCustomerVersion: 'Number of Printing Customer Version',
  reprintSalesReciept: 'Reprint Sales Reciept',
  tips: 'Hant',
  updatedTips: 'Ticket Setting Updated！',
  precept: 'Precept',
  cashierAndName: 'Cashier：Sam',
  assistantAndName: 'Assistant：1001-Wang Xiao',
  storeNoAndName: 'Store No.：1009-channel',
  storeAddrAndName: 'Store Addr：Tian\'an Energy-saving Science and Technology Park, Panyu District, Guangzhou',
  payable: 'Payable',
  cash: 'Cash',
  integralBalance: 'Integral Balance',
  printThirtpartOrder: 'Payment Serial No.',
  thridSeralNumber: '3-rd  Party Payment Merchant Payment Serial No.',
  TicketNumberEdited: 'Ticket number edited!',
  TicketNumberEditedError1: 'Enter a number between 0-3',
  TicketNumberEditedError2: 'Quty cannot exceed 3',
  photoUploadTips: 'Note: Select photos first, can use mouse to adjust size and position to ideal printing effect. Such as over the border, the picture will follow 300: 130 to crop.',
  selectPhotos: 'Select Photos',
  leftTurn: 'Left-Turn',
  rightTurn: 'Right-Turn',
  upload: 'Upload',
  confirm: 'Confirm',
  markSet: 'Mark Settings',
  markSetMsg: 'Hide "Channel Version/Customer Version" Mark',
  markSetCustomer: 'Customer Version',
  invoiceScanUrlText: 'Invoice OR Code',
  invoiceScanUrl: 'Show Invoice OR Code（ERP Related Controls Have been Set）',
  invoiceDesc: 'Invoice Des',
  '添加二维码': '添加二维码',
  '请输入二维码内容': '请输入二维码内容',
  '自定义二维码': '自定义二维码',
  '二维码描述': '二维码描述',
  '销售单号': '销售单号',
  '手工单号': '手工单号',
  '会员卡号': '会员卡号',
  '会员手机': '会员手机',
  etc: ' etc',
  Coupon: ' Coupon',
  Date: 'Date',
  printCoupons: 'Print Coupon',
  promoteCounpon: 'Promotional Coupons',
  rechargeCounpon: 'Top-Up Coupons',
  primeCostInfo: 'Original Price Total',
  primeCostInfoDetail: '(The total price tag of goods)',
  DiscountTotal: 'Discounted Price',
  alreadyDiscountInfo: 'Discounted',
  alreadyDiscountInfoDetail: '(Discounted=The price tag-Total amount payable)',
  实付: 'actual payment',
  生意额: 'Business volume',
  getIntegrateInfo: 'Get Integral',
  remainingIntegrateInfo: 'Integral balance',
  uploadPhoto: 'Upload Photos',
  autoSavePhoto: 'Auto Generate Barcode Pic',
  autoSelectNum: 'Select Auto Generate Barcode Ticket No.',
  Saleno: 'Sale Ticket No.',
  manualSaleNo: 'Manual Receipt No.',
  barCode: 'barCode',
  qrCode: 'QRcode',
  takeCareMsg: 'Notice: Manual Receipt No. is longer, and will be over-length if exchange to Barcode that cannot be scanned, suggest to use QR Code',
  cancelMsg: 'Cancel',
  saveMsg: 'Save',
  addParagraph: '+Add Paragraph',
  addEmptyParagraph: '+Add Blank Line',
  paragraphMsg: 'Paragraph',
  leftAlign: 'Left alignment',
  centerAlign: 'Centered',
  deleteMsg: 'Delete',
  blankLine: 'Blank Line',
  goodsSpace: 'Goods Display',
  goodsSpaceMsg: 'Separated by blank lines between goods',
  showGoodsTotal: 'Goods Total',
  showGoodsTotalMsg: 'Display Total',
  middlePic: 'Custom Image',
  tailImageDesc: 'Image Caption',
  barCodeStyle: 'SKU Style',
  smallTicketNum: 'Ticet No.',
  goodsType10: 'SKU',
  goodsType10Unique: 'Unique Code',
  goodsType17: 'SKU/Unique Code',
  goodsType2: 'SKU/Name',
  goodsType2Unique: 'Unique Code/Name',
  goodsType22: 'SKU/Category',
  goodsType22Unique: 'Unique Code/Category',
  goodsType4: 'SKU/Name/Tag Price',
  goodsType4Unique: 'Unique Code/Name/Tag Price',
  goodsType44: 'SKU/Category/Tag Price',
  goodsType44Unique: 'Unique Code/Category/Tag Price',
  goodsType5: 'SKU/Name/VIP Price/Discounted Price',
  goodsType5Unique: 'Unique Code/Name/VIP Price/Discounted Price',
  goodsType55: 'SKU/Category/VIP Price/Discounted Price',
  goodsType55Unique: 'Unique Code/Category/VIP Price/Discounted Price',
  goodsType7: 'SKU/Name/VIP Price/DCT/Discounted Price',
  goodsType7Unique: 'Unique Code/Name/VIP Price/DCT/Discounted Price',
  goodsType77: 'SKU/Category/VIP Price/DCT/Discounted Price',
  goodsType77Unique: 'Unique Code/Category/VIP Price/DCT/Discounted Price',
  goodsType1: 'Goods NO.-Name/Color/Length/Size',
  goodsType6: 'Goods NO.-Name/Color/Length/Size/VIP Price/Discounted Price',
  goodsType8: 'Goods NO.-Name/Color/Length/Size/VIP Price/DCT/Discounted Price',
  goodsType3: 'Goods NO.-Name/Color/Length/Size/Tag Price',
  goodsType9: 'Goods NO.-Name/Color/Length/Size/Tag Price/DCT/Discounted Price',
  goodsType11: 'Goods NO.-Category/Color/Length/Size',
  goodsType66: 'Goods NO.-Category/Color/Length/Size/VIP Price/Discounted Price',
  goodsType88: 'Goods NO.-Category/Color/Length/Size/VIP Price/DCT/Discounted Price',
  goodsType33: 'Goods NO.-Category/Color/Length/Size/Tag Price',
  goodsType99: 'Goods NO.-Category/Color/Length/Size/Tag Price/DCT/Discounted Price',
  goodsType100: 'Goods NO.-Category/Color/Length/Size/RetailPrice/DCT/Discounted Price',
  categoryReplaceName: 'Use Goods Class instead of Goods Name',
  uniqueReplaceBarcode: 'Use Unique Code instead of Barcode',
  Amt_mang: 'Amt ',
  Available: ' Available',
  '渠道配置中心': 'Configuration Center',
  '单据打印样式管理': 'Document Printing Style Manager',
  '配置样式请至渠道配置中心操作': 'Set Style in "Configuration Center"',
  '单据': 'Invoice',
  '新增简易版样式': 'New Simple Version',
  '新增定义版样式': 'New Custom Version',
  '自定义版': 'Custom',
  '简易版': 'Simple',
  '简易版编辑器': 'Simple Editor',
  '自定义编辑器': 'Custom Editor',
  '空样式': ' Style',
  '样式名称': 'Style Name',
  '样式文档名称': 'Style Name',
  '输入样式文档名称': 'Enter Style Name',
  '建议备注宽度以便区分': 'Recommended note width for easy differentiation',
  '图片大小不超过': 'Picture Size is Less than ',
  '选择单据': 'Select Receipt',
  '选择模版': 'Select Template',
  '空白模版': 'Blank Template',
  '请检查样式是否缺漏': 'Please check for missing styles',
  '您正在进行模版编辑操作, 是否放弃编辑?': 'You are editing a template. Do you want to abandon editing?',
  '销售单': 'Sales',
  '定金单': 'Deposit',
  '日结': 'Day-End',
  '交接班': 'Shift Change',
  '本机日收银': 'Day\'s Cashier of Machine',
  '充值单': 'Top-Up',
  '调拨收货': 'Allocates Receive Goods',
  '采购收货': 'Purchases Receive Goods',
  '渠道收货': 'Channel Receive Goods',
  '渠道调拨': 'Channel Allocate Goods',
  '渠道退货': 'Channel Return Goods',
  '仓库出货': 'Warehouse Shipping',
  '渠道采购到货通知': 'Channel Arrive Notice',
  '渠道调出通知': 'Channel Callout Notice',
  '退货通知': 'Return Notice',
  '渠道采购退货通知': 'Channel Purchase Return Notice',
  '线上订单发货': 'Online Order Delivery',
  '收货单': 'Receiving Invoice',
  '成品采购入库单(基础)': 'End Product Purchase Storage Invoice(Basic)',
  '发货单': 'Delivery Invoice',
  '采购退货': 'Purchases Return Goods',
  '紧急发货(基础)': 'Urgent Deliver(Basic)',
  '配货单(基础)': 'Distribution  Invoice(Basic)',
  '发货退货(基础)': 'Delivery Return(Basic)',
  '到货通知单(基础)': 'Arrive Notice(Basic)',
  '采购退货(基础)': 'Purchase Return(Basic)',
  '采购退货通知(基础)': 'Purchase Return Notice(Basic)',
  '验货(基础)': 'OMS Inspection(Basic)',
  '自定义文本': 'Custom Text',
  '模版名称': 'Template Name',
  '模板已保存': 'Template saved',
  '可通过渠道配置中心配置渠道使用': 'Can be used by "Configuration Center"',
  '选择样式': 'Select Style',
  '税额': 'GST Amt',
  '显示税额': 'Show GST Amt',
  '买满立减(按单)': 'Deduct at certain Amt (by Bill)',
  '买满打折(按货品)': 'Deduct at certain Amt (by Goods)',
  '买满送优惠券': 'Coupon back at certain amt',
  '顾客签名栏': 'SIGNATURE',
  '打印太阳码': 'Print Sun Code',
  '显示顾客签名栏': 'Print Customer Signature Bar',
  '显示已用代用券券号': 'Print Used Coupon No.',
  '已用代用券': 'Coupon No.',
  '折扣取反(适用于非中国大陆地区)': 'Reverse Discount (For Non-Mainland China)',
  '会员姓名': 'VIP Name',
  '会员等级': 'VIP Level',
  '营业员(货品)': 'STAFF NAME(GOODS)',
  'A4显示货品营业员': 'Print Staff Name of Goods（ONLY A4）',
  '代用券': 'Coupon No.',
  '营业员': 'STAFF NAME',
  '顾客签名': 'SIGNATURE',
  '渠道调入': 'Channel Call-in',
  '发货': 'Deliver',
  '配单': '',
  '退货': 'Return',
  '定金单号': 'Deposit Receipt No.',
  '核销单号': 'Sales-Order No.',
  'printCounterChannelAbb': 'shoppe',
  'printCounterChannelAbbs': 'shoppe',
  '活动说明': '',
  '显示赠送代用券活动说明': '',
  '批量打印': '',
  '顺丰面单打印': '',
  '零售配单验货': '',
  '销补发货': '',
  '收货工作台': '',
  '线上订单工作台': '',
  维修单: '维修单',
  补货: '补货',
  '发快递（影儿）': '发快递（影儿）',
  '价签打印': 'Price Label Printing'
}



// WEBPACK FOOTER //
// ./src/i18n/en/slip.js